import { toIntOrNull, toBoolOrNull } from '@utils/parse';
import { useApiModel } from '@hooks/use-api-model';
import { useApiSubmit } from '@hooks/use-api-submit';
import { DashRegistrationStep } from '@/types/dashboard';
import { defaultScreeningProgress } from '@/types/screening/screening-progress';
import type {
    IAssessKidneyStonesFormValues,
    IAssessKidneyStonesModel,
    IAssessKidneyStonesSubmitResult,
} from '@/types/screening/assess-kidney-stones';

const ASSESS_KIDNEY_STONES_ENDPOINT = '/api/register/assess-kidney-stones';

const defaultAssessKidneyStonesModel: IAssessKidneyStonesModel = {
    ...defaultScreeningProgress,
    currentRegistrationStep: DashRegistrationStep.AssessKidneyStones,
    hasHadKidneyStones: null,
    kidneyStoneEpisodes: null,
    kidneyStoneRemissionStatus: null,
    kidneyStoneTreatment: null,
};

export const useAssessKidneyStones = (registrationId: number, editKey: string) => {
    const url = `${ASSESS_KIDNEY_STONES_ENDPOINT}/${registrationId}/${editKey}`;

    const { model, isLoading, error } = useApiModel(url, defaultAssessKidneyStonesModel);

    const { submit, isSubmitting, submitError } = useApiSubmit<
        IAssessKidneyStonesFormValues,
        DashRegistrationStep,
        IAssessKidneyStonesSubmitResult
    >(
        url,
        (values) => {
            const hasHadKidneyStones = toBoolOrNull(values.hasHadKidneyStones);
            const applies = hasHadKidneyStones === true;

            return {
                hasHadKidneyStones,
                kidneyStoneEpisodes: applies ? toIntOrNull(values.kidneyStoneEpisodes) : null,
                kidneyStoneRemissionStatus: applies
                    ? toIntOrNull(values.kidneyStoneRemissionStatus)
                    : null,
                kidneyStoneTreatment: applies ? toIntOrNull(values.kidneyStoneTreatment) : null,
            };
        },
        (nextStep) => ({ nextStep }),
    );

    return { model, isLoading, error, submit, isSubmitting, submitError };
};
